import { Box, IconButton } from "@mui/material";
import CustomDataGridV2 from "../../../../components/CustomDataGridV2";
import Flex from "../../../../components/Flex";
import ToggleSwitch from "../../../../components/ToggleSwitch";
import { UserData } from "../../../../dummy-data/user-data";
import { GridColDef, GridSortItem } from "@mui/x-data-grid";
import Text from "../../../../components/Text";
import VerifiedIcon from "@mui/icons-material/Verified";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { UserCardData } from "../../../../types/user-types";
import { useState } from "react";
import ProviderUserModal from "../../../../components/app/admin/provider-groups/ProviderUserDrawer";
import { PROVIDER_USER_EDIT_INITIAL_VALUES } from "../../../../constants/ProviderUserSchema";
import ProviderProfileDrawer from "../../../../components/app/ProviderProfileDrawer";
import { useReduceDisclosure } from "../../../../hooks/use-reduce-disclosure";
import { useUsersList } from "../../../../queries/use-get-users";
import { DEFAULT_PAGE_SIZE, DGT_Pagination } from "../../../../utils/utils";

const ProviderUserTable = () => {
  const [pagination, setPagination] = useState<DGT_Pagination>({
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const { data: providersList } = useUsersList({
    gridSorting,
    pagination: {
      page: pagination.page,
      pageSize: pagination.pageSize,
    },
  });
  const COLUMNS: GridColDef<UserData>[] = [
    {
      field: "id",
      flex: 0.5,
      minWidth: 80,
      disableColumnMenu: true,
      headerName: "User ID",
      sortable: false,
    },
    {
      field: "userInfo",
      flex: 0.6,
      minWidth: 200,
      disableColumnMenu: true,
      headerName: "User Name",
      renderCell: ({ row }) => (
        <Text
          onClick={() => providerProfileModalDisclosure.open()}
          marginBottom={"3px"}
          color={"primary.main"}
          fontWeight={"medium"}
          sx={{ cursor: "pointer" }}
        >
          {row?.firstName + " " + row?.lastName}
        </Text>
      ),
      sortable: false,
    },
    {
      field: "role",
      flex: 0.8,
      minWidth: 130,
      disableColumnMenu: true,
      headerName: "Role",
      sortable: false,
    },
    {
      field: "phone",
      flex: 0.6,
      minWidth: 140,
      disableColumnMenu: true,
      headerName: "Contact",
      sortable: false,
    },
    {
      field: "email",
      flex: 0.9,
      minWidth: 240,
      disableColumnMenu: true,
      headerName: "Email",
      renderCell: ({ value }) => (
        <Flex alignItems={"center"} gap={"4px"}>
          <VerifiedIcon
            color={value.is_verified ? "success" : "disabled"}
            fontSize="small"
          />
          <Text>{value.mail}</Text>
        </Flex>
      ),
      sortable: false,
    },
    {
      field: "last_login",
      flex: 0.7,
      minWidth: 150,
      disableColumnMenu: true,
      headerName: "Last Sign In",
      sortable: false,
    },
    {
      field: "active",
      disableColumnMenu: true,
      headerName: "Status",
      width: 150,
      renderCell: ({ ...params }) => {
        return <ToggleSwitch checked={params.value} />;
      },
      sortable: false,
    },
    {
      field: "Action",
      width: 90,
      disableColumnMenu: true,
      renderCell: ({ row }) => (
        <IconButton onClick={() => handleOpenEditProfileModal(row as any)}>
          <ModeEditOutlineOutlinedIcon color="primary" />
        </IconButton>
      ),
    },
  ];

  const [editProviderUserModalDisclosure, providerProfileModalDisclosure] =
    useReduceDisclosure(2);

  const [selectedUserData, setSelectedUserData] = useState<UserCardData | null>(
    null
  );

  function handleOpenEditProfileModal(user?: UserCardData) {
    if (user) setSelectedUserData(user);
    editProviderUserModalDisclosure.open();
  }

  return (
    <Box height={"110%"} width={"100%"}>
      <CustomDataGridV2
        getRowId={(row) => row.uuid}
        rows={providersList?.data?.content ?? []}
        columns={COLUMNS}
        disableRowSelectionOnClick
        paginationModel={pagination}
        onPaginationModelChange={setPagination}
        onSortModelChange={setGridSorting}
      />

      <ProviderProfileDrawer
        disClosureHost={providerProfileModalDisclosure}
        providerUuid={selectedUserData?.uuid}
      />
      {/*todo need to remove if not use future reference
       <DeleteModal
        w="20vw"
        open={openedDeleteModal}
        onClose={closeDeleteModal}
        id={deleteId}
        onConfirmation={(id) => {
          closeDeleteModal();
        }}
        content={"You want to delete this User"}
      /> */}

      <ProviderUserModal
        open={editProviderUserModalDisclosure.opened}
        title={"Edit Provider User"}
        onClose={editProviderUserModalDisclosure.close}
        onSubmit={() => {
          return new Promise(() => {});
        }}
        // todo need to change prefill values as per selected user data
        prefillValues={PROVIDER_USER_EDIT_INITIAL_VALUES ?? selectedUserData}
        isAdminAccessField
      />
    </Box>
  );
};

export default ProviderUserTable;
